import { type TFunction } from 'i18next';

export const attemptErrorTranslation = (
  key: string,
  text: string,
  t: TFunction,
): string => {
  const translationKey = `global.forms.validationErrors.${key}`;
  const translated = t(translationKey);
  // No translation found
  if (translated === translationKey) return text;

  return translated;
};

export const capitalize = (string: string): string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
